<div class="table-responsive" [class.overflow-hidden]="emptyRowService.emptyRow.length > 0">
    <table
           (click)="onTableClicked($event)"
           class="table table-striped table-hover directory-list-table footable">
        <thead>
            <tr [ngClass]="{'noSort': data.length < 2}">
                <th></th>
                <th (click)="orderBy('name', $event)" class="footable-sorted">
                    Name <span class="footable-sort-indicator"></span>
                </th>
                <th>Phone</th>
                <th>City</th>
                <th>Category</th>
                <th *ngIf="!directoryService.showDetailedView">List</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of data; let index = index" (click)="$event.showDropdown || toggleCheck(item)">
                <td>
                    <label class="img-checkbox">
                        <input type="checkbox" [ngModel]="item.checked">
                        <label><svg-checked></svg-checked></label>
                    </label>
                </td>
                <td>{{item.name}}</td>
                <td>{{item.primaryPhone || '-'}}</td>
                <td>{{item.primaryCity || '-'}}</td>
                <td class="table-hint-td" (click)="$event.showDropdown = item.categories.length > 1">
                    <div *ngIf="item.categories.length > 0" class="list-items">
                        <div class="single-item-label label">{{ item.categories[0].name }}</div>

                        <button *ngIf="item.categories.length > 1" class="list-items__btn">...</button>

                        <div class="list-items__drop-down table-hint {{index > 7 ? 'up' : 'down'}}">
                            <div class="list-items__drop-down__content">
                                <span *ngFor="let item of item.categories | slice:1" class="label">
                                    {{ item.name }}
                                </span>
                            </div>
                        </div>
                    </div>
                </td>
                <td *ngIf="!directoryService.showDetailedView"
                    class="table-hint-td"
                    (click)="$event.showDropdown = item.corporationsAndLists.length > 1">
                    <div *ngIf="item.corporationsAndLists.length > 0" class="list-items">
                        <div class="single-item-label label">{{ item.corporationsAndLists[0].name }}</div>

                        <button *ngIf="item.corporationsAndLists.length > 1" class="list-items__btn">...</button>

                        <div class="list-items__drop-down table-hint {{index > 7 ? 'up' : 'down'}}">
                            <div class="list-items__drop-down__content">
                                <span *ngFor="let item of item.corporationsAndLists | slice:1" class="label">
                                    {{ item.name }}
                                </span>
                            </div>
                        </div>
                    </div>
                </td>
            </tr>
            <tr *ngFor="let item of emptyRowService.emptyRow" style="cursor: default;">
                <td><div class="psevdo-checkbox"></div></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td *ngIf="!directoryService.showDetailedView"></td>
            </tr>
        </tbody>
    </table>

    <empty-result-message
        [isEmpty]="!directoryService.directoryData['vendors'].total"
        [isServiceUnavailable]="directoryService.showServiceUnavailable"
        [isLoading]="directoryService.spinnerShow">
        You have no vendors listed on the system<br>
        <span *ngIf="directoryService.account.canUpdate('bldn')">
            <a href="javascript://" (click)="directoryService.showModal()" class="mtv-primary-color clickable-text">add a vendor</a> now
        </span>
    </empty-result-message>
</div>



// WEBPACK FOOTER //
// /app/src/app/components/directory/list/vendors-list/vendors-list.component.html